import axios from "axios";

export class LocationDataManager {
    // Champs privés
    #regionAttribute; #countryAttribute; #prefectureAttribute; #municipalityAttribute; 
    #districtAttribute; #sectorAttribute;#squareAttribute;

    constructor() {
        this.url = "";
        this.method = "";
        this.data = {};
        // id:
        this.countryId = "#countryId";
        this.regionId = "#regionId";
        this.prefectureId = "#prefectureId";
        this.municipalityId = "#municipalityId";
        this.districtId = "#districtId";
        this.sectorId = "#sectorId";
        this.squareId = "#squareId";
        this.suffix = "";
        // url
        this.getAllCountryUrl = "get-all-country";
        this.regionByCountryUrl = "regions.get-by-paysid";
        this.prefectureByRegionUrl = "prefectures.get-by-regionid";
        this.municipalityByPrefecutreUrl = "prefectures.get-communes-by-prefecture";
        this.districtByMunicipalityUrl = "quartiers.get-by-commune";
        this.sectorByDistrictUrl = "sector-by-district";
        this.squareBySectorUrl = "square-by-sector";
        // combo box control
        this.#countryAttribute = "setRegionByCountry";
        this.#regionAttribute = "setPrefectureByRegion";
        this.#prefectureAttribute = "setMunicipalityByPrefecture";
        this.#municipalityAttribute = "setDistrictByMunicipality";
        this.#districtAttribute = "setSectorByDistrict";
        this.#sectorAttribute = "setSquareBySector";

        this.#squareAttribute = "not_undefined_yet";

        this.init();
    }

    init() {
        if($(`select[${this.#countryAttribute}]`).length != 0){
            $(`select[${this.#countryAttribute}]`).on('change', (e) => this.#getRegionByCountryAndModifyComboBox(e.target));
        }

        if($(`select[${this.#regionAttribute}]`).length != 0){
            $(`select[${this.#regionAttribute}]`).on('change', (e) => this.#getPrefectureByRegionAndModifyComboBox(e.target));
        }

        if($(`select[${this.#prefectureAttribute}]`).length != 0){
            $(`select[${this.#prefectureAttribute}]`).on('change', (e) => this.#getMunicipalityByPrefectureAndModifyComboBox(e.target));
        }

        if($(`select[${this.#municipalityAttribute}]`).length != 0){
            $(`select[${this.#municipalityAttribute}]`).on('change', (e) => this.#getDistrictByMunicipalityAndModifyComboBox(e.target));
        }

        if($(`select[${this.#districtAttribute}]`).length != 0){
            $(`select[${this.#districtAttribute}]`).on('change', (e) => this.#getSectorByDistrictAndModifyComboBox(e.target));
        }

        if($(`select[${this.#sectorAttribute}]`).length != 0){
            $(`select[${this.#sectorAttribute}]`).on('change', (e) => this.#getSquareBySectorAndModifyComboBox(e.target));
        }
    }

    
    

    #getRegionByCountryAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#countryAttribute);
        const paysId = $(comboBox).val();

        this.initComboBoxOnCountryAction();

        if (paysId !== "") {
            axios.get(route(this.regionByCountryUrl, { paysId: paysId })).then((response)=>{                
                let html = "";
                let data = response.data;
                if(response.data.regions){
                    data = response.data.regions;
                }
                data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.regionId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting regions: ", err)
            })
        }
    }

    #getPrefectureByRegionAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#regionAttribute);
        const regionId = $(comboBox).val();

        this.initComboBoxOnRegionAction();

        if (regionId !== "") {
            axios.get(route(this.prefectureByRegionUrl, { regionId: regionId })).then((response)=>{                
                let html = "";

                let data = response.data;
                if(response.data.prefectures){
                    data = response.data.prefectures;
                }
                data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.prefectureId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting prefectures: ", err)
            })
        }
    }

    #getMunicipalityByPrefectureAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#prefectureAttribute);
        const prefectureId = $(comboBox).val();
        this.initComboBoxOnPrefectureAction();
        
        // console.log('combox: ',comboBox);
        // console.log('prefecture id: ', prefectureId);

        if (prefectureId !== "") {
            axios.get(route(this.municipalityByPrefecutreUrl, { prefecture : prefectureId })).then((response)=>{                
                let html = "";

                let data = response.data;

                if(response.data.communes){
                    data = response.data.communes;
                }

                data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.municipalityId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting communes: ", err)
            })
        }
    }

    #getDistrictByMunicipalityAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#municipalityAttribute);
        const municipalityId = $(comboBox).val();
        this.initComboBoxOnMunicipalityAction();

        if (municipalityId !== "") {
            axios.get(route(this.districtByMunicipalityUrl, { communeId : municipalityId })).then((response)=>{                
                let html = "";
                let data = response.data;

                if(response.data.districts){
                    data = response.data.districts;
                }

                data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.districtId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting district: ", err)
            })
        }
    }

    #getSectorByDistrictAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#districtAttribute);
        const districtId = $(comboBox).val();
        this.initComboBoxOnDistrictAction();

        if (districtId !== "") {
            axios.get(this.sectorByDistrictUrl, { districtId : districtId }).then((response)=>{                
                let html = "";
                let data = response.data;

                if(response.data.sectors){
                    data = response.data.sectors;
                }

                data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.sectorId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting Sector: ", err)
            })
        }
    }

    #getSquareBySectorAndModifyComboBox(comboBox) {
        this.suffix = $(comboBox).attr(this.#sectorAttribute);
        const sectorId = $(comboBox).val();
        this.initComboBoxOnSectorAction();

        if (sectorId !== "") {
            axios.get(this.squareBySectorUrl, { sectorId : sectorId }).then((response)=>{                
                let html = "";
                response.data.forEach(item => {
                    html+= `<option value='${item.id}'>${item.label}</option>`
                });

                $(this.squareId + this.suffix).append(html);

            }).catch((err)=>{
                console.log("Erreur When getting Square: ", err)
            })
        }
    }

    /**
     * Get all countries
     * @param {*} paysId 
     * @returns 
     */
    async getAllCountry(paysId) {
        const response =  await  axios.post(this.getAllCountryUrl);
        return response.data; 
    }


    /**
     * Get regions by country id
     * @param {*} paysId 
     * @returns 
     */
    async getRegionByCountry(paysId) {
        if (paysId !== "") {
            const response =  await  axios.post(this.regionByCountryUrl, { paysId: paysId });
            return response.data;            
        }

        return [];

    }

    /**
     * Get prefectures by region id
     * @param {*} regionId 
     * @returns 
     */
    async getPrefectureByRegion(regionId) {
        if (regionId !== "") {
            const response =  await  axios.post(this.prefectureByRegionUrl, { regionId: regionId });
            return response.data;            
        }

        return [];
    }


    /**
     * Get munipalities by prefecture id
     * @param {*} prefectureId 
     * @returns 
     */
    async getMunicipalityByPrefecture(prefectureId) {
        if (prefectureId !== "") {
            const response =  await  axios.post(this.municipalityByPrefecutreUrl, { prefectureId: prefectureId });
            return response.data;            
        }

        return [];
    }

    /**
     * Get districts by munipality id
     * @param {*} municipalityId 
     * @returns 
     */
    async getDistrictByMunipality(municipalityId) {
        if (municipalityId !== "") {
            const response =  await  axios.post(this.districtByMunicipalityUrl, { municipalityId: municipalityId });
            return response.data;            
        }

        return [];
    }

    /**
     * Get sectors by district id
     * @param {*} districtId 
     * @returns 
     */
    async getSectorByDistrict(districtId) {
        if (districtId !== "") {
            const response =  await  axios.post(this.sectorByDistrictUrl, { districtId: districtId });
            return response.data;            
        }

        return [];
    }

    /**
     * Get squares by sector id
     * @param {*} sectorId 
     * @returns 
     */
    async getSquareBySector(sectorId) {
        if (sectorId !== "") {
            const response =  await  axios.post(this.squareBySectorUrl, { sectorId: sectorId });
            return response.data;            
        }

        return [];
    }



    initComboBoxOnCountryAction(){
        $(this.regionId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.prefectureId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.municipalityId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.sectorId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }


    initComboBoxOnRegionAction(){
        $(this.prefectureId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.municipalityId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.sectorId + this.suffix).empty().append("<option value=''>Séléctionnez le sector</option>");
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }


    initComboBoxOnPrefectureAction(){
        $(this.municipalityId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.sectorId + this.suffix).empty().append("<option value=''>Séléctionnez le sector</option>");
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }

    initComboBoxOnMunicipalityAction(){
        $(this.districtId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.sectorId + this.suffix).empty().append("<option value=''>Séléctionnez </option>");
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }


    initComboBoxOnDistrictAction(){
        $(this.sectorId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }

    initComboBoxOnSectorAction(){
        $(this.squareId + this.suffix).empty().append("<option value=''>Séléctionnez</option>");
    }


}
